// eslint-disable-next-line no-unused-vars
import { appInfo } from "./appinfo";

export const menuList = [
  {
    title: "Menu",
    id: "Dyt8xnbzif",
    menus: [
      {
        title: "Dashboard",
        icon: "ri-dashboard-fill",
        route: "dashboard",
        access: ["noPamNeed"],
      },
      
      {
        title: "Consent Management",
        icon: "ri-article-line",
        route: "menu",
        id: "07ca0abc9a75352087070a25",
        access: ["noPam"],
        subchildren: [
          {
            title: "New Consent",
            icon: "ri-file-list-line",
            route: "newConsent",
            access: ["noPam"],
          },
          {
            title: "All Consent",
            icon: "ri-file-list-line",
            route: "allConsents",
            access: ["noPam"],
          },
        ],
      },
      {
        title: appInfo?.type == "codsmi" ? "School" : "Institution",
        icon: " ri-school-line",
        route: "menu",
        id: "4AblV7v",
        access: ["y75281", "y11411", "y91085", "y48068"],
        subchildren: [
          {
            title:
              appInfo?.type == "codsmi" ? "All schools" : "All institutions",
            icon: "ri-file-list-line",
            route: "institutions",
            access: ["y75281"],
          },
          {
            title: appInfo?.type == "codsmi" ? "New school" : "New institution",
            icon: "ri-add-line",
            route: "newinstitution",
            access: ["y11411"],
          },
          {
            title:
              appInfo?.type == "codsmi"
                ? "School(s) with proprietor"
                : "institution(s) with director",
            icon: "ri-file-list-line",
            route: "assignedInstitution",
            access: ["y91085"],
          },
          {
            title:
              appInfo?.type == "codsmi"
                ? "Update school proprietor"
                : "Update institution director",
            icon: "ri-add-line",
            route: "assignInstitution",
            access: ["y48068"],
          },
        ],
      },
      {
        title: appInfo?.type == "codsmi" ? "Proprietor" : "Director",
        icon: " ri-team-line",
        route: "menu",
        id: "1rcavXiOq",
        access: ["y59821", "y92455"],
        subchildren: [
          {
            title:
              appInfo?.type == "codsmi" ? "All proprietors" : "All directors",
            icon: "ri-team-line",
            route: "directorList",
            access: ["y59821"],
          },
          {
            title:
              appInfo?.type == "codsmi" ? "New proprietor" : "New director",
            icon: "ri-user-add-line",
            route: "newdirector",
            access: ["y92455"],
          },
        ],
      },
      {
        title:
          appInfo?.type == "codsmi" ? "New Application" : "New Applications",
        icon: " ri-school-line",
        route: "mes.applications",
        id: "1rcavXiOq",
        access: ["y51910", "y17618"],
        // subchildren: [
        //   {
        //     title: appInfo?.type == "codsmi" ? "All proprietors" : "All directors",
        //     icon: "ri-team-line",
        //     route: "directorList",
        //     access: ["y82132554"],
        //   },
        //   {
        //     title: appInfo?.type == "codsmi" ? "New proprietor" : "New director",
        //     icon: "ri-user-add-line",
        //     route: "newdirector",
        //     access: ["y17618"],
        //   },
        // ],
      },
      {
        title: "Zonal D.O",
        icon: " ri-user-line",
        route: "menu",
        id: "TtzQPxC",
        access: ["y82132554", "y17618", "y45008", "y45036"],
        subchildren: [
          {
            title: "All zonal DOs",
            icon: "ri-team-line",
            route: "zonaldoList",
            access: ["y82132554"],
          },
          {
            title: "New zonal DO",
            icon: "ri-user-add-line",
            route: "newZonaldo",
            access: ["y17618"],
          },
          {
            title: "Assign DO",
            icon: "ri-add-line",
            route: "assign.z.officer",
            access: ["y45036"],
          },

          {
            title: "Assigned DOs",
            icon: "ri-file-2-line",
            route: "assigned.z.officer",
            access: ["y45008"],
          },
        ],
      },
      {
        title: "LGA D.O",
        icon: " ri-user-line",
        route: "menu",
        id: "FEn3z5dky",
        access: ["y27784", "y46585", "y83348", "y10235"],
        subchildren: [
          {
            title: "All lga DOs",
            icon: "ri-team-line",
            route: "lgadoList",
            access: ["y27784"],
          },
          {
            title: "New lga DO",
            icon: "ri-user-add-line",
            route: "newlgado",
            access: ["y46585"],
          },
          {
            title: "Assign DO",
            icon: "ri-add-line",
            route: "assign.lga.officer",
            access: ["y83348"],
          },
          {
            title: "Assigned DOs",
            icon: "ri-file-2-line",
            route: "assigned.lga.officer",
            access: ["y10235"],
          },
        ],
      },
   
      {
        title: "Users",
        icon: " ri-user-line",
        route: "menu",
        id: "j95op9e569VxUkZ427Ee",
        access: ["y58017", "y35283"],
        subchildren: [
          {
            title: "All users",
            icon: "ri-team-line",
            route: "userList",
            access: ["y58017"],
          },
          {
            title: "New user",
            icon: "ri-user-add-line",
            route: "newUser",
            access: ["y35283"],
          },
        ],
      },
    ],
  },
  {
    title: "Configurations",
    id: "NWPScaYLHT",
    menus: [
      {
        title: "Manage Year",
        icon: "bx bx-calendar",
        route: "menu",
        id: "phwkRhwmFZ",
        access: ["noPam"],
        subchildren: [
          {
            title: "Years",
            route: "years-list",
            icon: "ri-file-list-3-line",
            access: ["noPam"],
          },
          {
            title: "Create Year",
            route: "year-new",
            icon: "ri-add-circle-line",
            access: ["noPam"],
          },
        ],
      },
      {
        title: "Manage Form Documents",
        icon: "ri-file-2-fill",
        route: "menu",
        id: "fd0467b80978dfd550b67b62",
        access: ["noPam"],
        subchildren: [
          {
            title: "Form Documents",
            route: "form.list",
            icon: "ri-file-list-3-line",
            access: ["noPam"],
          },
          {
            title: "New Form Document",
            route: "form.create",
            icon: "ri-add-circle-line",
            access: ["noPam"],
          },
        ],
      },
    ],
  },
  {
    title: "Account Menu",
    id: "RaglsIozLG",
    menus: [
      {
        title: "Manage Invoices",
        // icon: "ri-file-paper-2-line",
        icon: "ri-file-paper-line",
        route: "invoice-list",
        // id: "JSYfZ2ZYbm",
        access: ['y55721'],
        // subchildren: [
        //   {
        //     title: "Create Invoice",
        //     icon: "ri-file-add-line",
        //     route: "invoice-create",
        //     access: ["y65820"],
        //   },
        //   {
        //     title: "Invoices",
        //     icon: "ri-file-list-2-line",
        //     route: "invoice-list",
        //     access: ["y55721"],
        //   },
        // ],
      },
      {
        title: "Manage Transactions",
        icon: "bx bx-money-withdraw",
        // icon: "ri-file-paper-2-line",
        route: "transactionList",
        // id: "4GfFJFwN1BwsOosWu4rS",
        access: ["y59766"],
        // subchildren: [
        //   {
        //     title: "Transactions",
        //     icon: "ri-file-add-line",
        //     route: "transactionList",
        //     access: ["y59766"],
        //   },
        // ],
      },
      {
        title: "Settings",
        icon: "ri-settings-2-fill",
        route: "menu",
        id: "HX2jEkeTU0",
        access: ["y99468", "y37228", "y53416"],
        subchildren: [
          {
            title: "App info",
            route: "appInfo",
            icon: "ri-wallet-line",
            access: ["y53416"],
          },
          {
            title: "All roles",
            route: "role-mng",
            icon: "ri-wallet-line",
            access: ["y37228"],
          },
          {
            title: "New role",
            route: "newRole",
            icon: "ri-add-circle-line",
            access: ["y99468"],
          },
        ],
      },
    ],
  },
];
